import { render, staticRenderFns } from "./subscribePopup.vue?vue&type=template&id=23ef8bb5&scoped=true&"
import script from "./subscribePopup.vue?vue&type=script&lang=ts&"
export * from "./subscribePopup.vue?vue&type=script&lang=ts&"
import style0 from "./subscribePopup.vue?vue&type=style&index=0&id=23ef8bb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef8bb5",
  null
  
)

export default component.exports